import { useLocation } from "react-router-dom";
import { useGetSessionQuery } from "../api/apiSlice";
import { useSilentAuthGuard } from "../hooks/useSilentAuthGuard";
import SnackbarComponent from "../components/snackbar/SnackbarComponent";
import App from "../App";
import { getHostname } from "../utils/getHostname";
import { useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";

const GatewayIndicator = () => {
  return (
    <div
      style={{
        width: "80px",
        height: "80px",
        backgroundColor: "#212121",
        borderRadius: "30%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        width="50"
        height="50"
        viewBox="0 0 40 40"
        style={{ animation: "spin 1s linear infinite" }}
      >
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="hsl(63, 100%, 20%)" />
            <stop offset="100%" stopColor="hsl(63, 100%, 70%)" />
          </linearGradient>
        </defs>
        <circle
          cx="20"
          cy="20"
          r="16"
          stroke="url(#my_gradient)"
          strokeWidth="2"
          fill="none"
        />
      </svg>

      {/* Add the animation keyframes */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          svg {
            transform-origin: center;
          }
        `}
      </style>
    </div>
  );
};

const RootLayout = () => {
  useSilentAuthGuard();

  const { data: session, isLoading } = useGetSessionQuery();
  const [isReady, setIsReady] = useState(false);

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const hostname = getHostname();
  const theme = useTheme();

  useEffect(() => {
    document.title = "ReMoni - Portal";
  }, [hostname, pathnames]);

  // Wait until loading finishes, then delay display to avoid flicker
  useEffect(() => {
    if (!isLoading) {
      const delay = setTimeout(() => {
        setIsReady(true);
      }, 500); // adjust delay time as needed (e.g., 300ms)

      return () => clearTimeout(delay);
    }
  }, [isLoading]);

  if (!isReady || isLoading) {
    return (
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: theme.palette.background.default,
          color: theme.palette.text.primary,
        }}
      >
        {/* <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', mb: 4 }}>
          <Typography
            variant="h4"
            className="Re"
            sx={{
              fontFamily: 'neuropolitical',
              color: (theme) =>
                theme.palette.mode === 'light' ? 'hsl(0, 0%, 20%)' : 'hsl(0, 0%, 85%)',
              fontWeight: 'medium',
            }}
          >
            Re
          </Typography>
          <Typography
            variant="h4"
            className="M"
            sx={{
              fontFamily: 'neuropolitical',
              color: 'hsl(63, 100%, 40%)',
              fontWeight: 'medium',
            }}
          >
            M
          </Typography>
          <Typography
            variant="h4"
            className="oni"
            sx={{
              fontFamily: 'neuropolitical',
              color: (theme) =>
                theme.palette.mode === 'light' ? 'hsl(0, 0%, 20%)' : 'hsl(0, 0%, 85%)',
              fontWeight: 'medium',
            }}
          >
            oni
          </Typography>
        </Box> */}
        <GatewayIndicator />
        {/* <Typography variant="body1" mt={2}>
          Validating current session...
        </Typography> */}
      </Box>
    );
  }

  if (!session?.authenticated) {
    return (
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: theme.palette.background.default,
          color: theme.palette.text.primary,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <Typography
            variant="h4"
            className="Re"
            sx={{
              fontFamily: "neuropolitical",
              color: (theme) =>
                theme.palette.mode === "light"
                  ? "hsl(0, 0%, 20%)"
                  : "hsl(0, 0%, 85%)",
              fontWeight: "medium",
            }}
          >
            Re
          </Typography>
          <Typography
            variant="h4"
            className="M"
            sx={{
              fontFamily: "neuropolitical",
              color: "hsl(63, 100%, 40%)",
              fontWeight: "medium",
            }}
          >
            M
          </Typography>
          <Typography
            variant="h4"
            className="oni"
            sx={{
              fontFamily: "neuropolitical",
              color: (theme) =>
                theme.palette.mode === "light"
                  ? "hsl(0, 0%, 20%)"
                  : "hsl(0, 0%, 85%)",
              fontWeight: "medium",
            }}
          >
            oni
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <SnackbarComponent />
      <App />
    </>
  );
};

export default RootLayout;
